import scrollama from 'scrollama';
import { scaleThreshold } from 'd3-scale';

const defaults = {
  target: '.scrolly .step-content'
};

export function init(config = {}) {
  const scroller = scrollama();
  const { target, map } = Object.assign(defaults, config);

  // Scales and factories
  const colorNeutral = scaleThreshold()
    .domain([])
    .range([
      'rgba(240, 240, 240, 0.1)'   // light grey
    ]);

  const colorMoment = scaleThreshold()
    .domain([1, 2])
    .range([
      'rgba(240, 240, 240, 0.1)',   // light grey
      'rgba(240, 59, 32, 0.75)',     // red
      'rgba(254, 178, 76, 1)'   // orange
    ]);

  const colorDay = scaleThreshold()
    .domain([1, 13, 97])
    .range([
      'rgba(240, 240, 240, 0.1)',   // light grey
      'rgba(240, 59, 32, 0.75)',     // red
      'rgba(240, 59, 32, 0.75)',     // red
      'rgba(240, 59, 32, 0.75)'     // red
    ]);

  const colorYearHighlightWeek = scaleThreshold()
    .domain([1, 7, 28])
    .range([
      'rgba(240, 240, 240, 0.1)',   // light grey
      'rgba(240, 240, 240, 0.1)',   // light grey
      'rgba(255, 237, 160, 0.75)',  // yellow
      'rgba(255, 237, 160, 0.75)'  // yellow
    ]);

  const colorYearHighlightMonth = scaleThreshold()
    .domain([1, 7, 28])
    .range([
      'rgba(240, 240, 240, 0.1)',   // light grey
      'rgba(240, 240, 240, 0.1)',   // light grey
      'rgba(240, 240, 240, 0.1)',   // light grey
      'rgba(240, 59, 32, 0.75)'     // red
    ]);

  const colorAvailability = scaleThreshold()
    .domain([1-24/365, 0.95, 1-7/365])
    .range([
      'rgba(240, 59, 32, 0.75)',     // red
      'rgba(254, 178, 76, 0.75)',   // orange
      'rgba(255, 237, 160, 0.75)',  // yellow
      'rgba(240, 240, 240, 0.1)'   // light grey
    ]);

  scroller
    .setup({
      step: document.querySelectorAll(target),
      offset: 1
    })
    // .onStepEnter(handleEnter)
    .onStepExit(handleExit);

  return scroller;

  function handleExit (response) {
    const step = response.element.dataset.step;

    if (response.direction == 'down') {
      if (step === '1') {
        map.drawDots('inactiveAtMoment', colorNeutral);
      }
    }

    if (response.direction == 'down') {
      if (step === '2') {
        map.drawDots('inactivePerMoment', colorMoment, 0);
      }
    }

    if (response.direction == 'down') {
      if (step === '3') {
        map.drawAnimatedDots('inactivePerMoment', colorMoment);
      }
    }

    // if (response.direction == 'down') {
    //   if (step === '4') {

    //   }
    // }


    if (response.direction == 'down') {
      if (step === '5') {
        map.stopAnimation();
        map.drawDots('inactiveAtDay', colorDay);
      }
    }

    if (response.direction == 'down') {
      if (step === '6') {
        map.drawDots('inactiveAtYear', colorYearHighlightWeek);
      }
    }

    if (response.direction == 'down') {
      if (step === '7') {
        map.drawDots('inactiveAtYear', colorYearHighlightMonth);
      }
    }

    if (response.direction == 'down') {
      if (step === '8') {
        map.drawDots('available', colorAvailability);
      }
    }




    if (response.direction == 'up') {
      if (step === '2') {
        map.drawDots('inactiveAtMoment', colorNeutral);
      }
    }

    if (response.direction == 'up') {
      if (step === '3') {
        map.stopAnimation();
        map.drawDots('inactivePerMoment', colorMoment, 0);
      }
    }

    // if (response.direction == 'up') {
    //   if (step === '4') {

    //   }
    // }

    if (response.direction == 'up') {
      if (step === '5') {
        map.drawAnimatedDots('inactivePerMoment', colorMoment);
      }
    }

    if (response.direction == 'up') {
      if (step === '6') {
        map.stopAnimation();
        map.drawDots('inactiveAtDay', colorDay);
      }
    }

    if (response.direction == 'up') {
      if (step === '7') {
        map.drawDots('inactiveAtYear', colorYearHighlightWeek);
      }
    }

    if (response.direction == 'up') {
      if (step === '8') {
        map.drawDots('inactiveAtYear', colorYearHighlightMonth);
      }
    }

    if (response.direction == 'up') {
      if (step === '9') {
        map.zoomTo([10.4, 51.6], 1 << 14);
        map.draw();
        map.drawDots('available', colorAvailability);
      }
    }
  }
}
